import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './clip.delete-many.reducer';

export const deleteManyClipsFeatureKey = 'deleteManyClips';
export const featureSelector = createFeatureSelector<State>(deleteManyClipsFeatureKey);

export const getDeleteManyClipsRecord = createSelector(
  featureSelector,
  (state: State): null => state.record
);

export const getDeleteManyClipsLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getDeleteManyClipsLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getDeleteManyClipsError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
